import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { formStyles } from 'consts/styles/Form';
import { userStyles } from 'consts/styles/User';

const DefaultComponent = props => {
  const { item, handleChange, defaultItem } = props;

  const formClasses = formStyles();
  const classesUser = userStyles();

  return item !== null ? (
    <FormControl
      className={`${classesUser.User}__wrapper__content__form-container__form`}
    >
      <InputLabel
        className={`${formClasses.Form}__label`}
        classes={{
          focused: `${formClasses.Form}__text-field--focused`,
        }}
        id={item.label}
      >
        {item.subtitle}
      </InputLabel>
      <Select
        className={`${formClasses.Form}__select`}
        labelId={item.label}
        id={item.name}
        name={item.name}
        value={defaultItem}
        classes={{
          root: `${formClasses.Form}__text-field`,
          icon: `${formClasses.Form}__text-field`,
        }}
        MenuProps={{
          className: `${formClasses.Form}__select__menu`,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          MenuListProps: {
            className: `${formClasses.Form}__select__menu__item`,
          },
          classes: {
            list: `${formClasses.Form}__select__menu--background-color`,
          },
          getContentAnchorEl: null,
        }}
        onChange={handleChange}
      >
        {item.menu.map(menu => (
          <MenuItem key={menu.key_} value={menu.value_}>
            {menu.key_}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : null;
};

DefaultComponent.propTypes = {
  item: PropTypes.object,
  handleChange: PropTypes.func,
  defaultItem: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default DefaultComponent;
